export default __webpack_public_path__ + "static/media/search.534936ee.svg";